"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServerStatusMonitorResponseType = /** @class */ (function () {
    /**
     *
     * @param status {string}
     */
    function ServerStatusMonitorResponseType(status) {
        this.status = status;
    }
    /**
     * @returns {ServerStatusMonitorResponseType}
     */
    ServerStatusMonitorResponseType.alert = function () {
        return new ServerStatusMonitorResponseType(this.ALERT);
    };
    /**
     * @returns {ServerStatusMonitorResponseType}
     */
    ServerStatusMonitorResponseType.warning = function () {
        return new ServerStatusMonitorResponseType(this.WARNING);
    };
    /**
     * @returns {ServerStatusMonitorResponseType}
     */
    ServerStatusMonitorResponseType.info = function () {
        return new ServerStatusMonitorResponseType(this.INFO);
    };
    /**
     * @returns {ServerStatusMonitorResponseType}
     */
    ServerStatusMonitorResponseType.success = function () {
        return new ServerStatusMonitorResponseType(this.SUCCESS);
    };
    /**
     * @returns {string}
     */
    ServerStatusMonitorResponseType.prototype.getStatus = function () {
        return this.status;
    };
    ServerStatusMonitorResponseType.ALERT = "alert";
    return ServerStatusMonitorResponseType;
}());
exports.ServerStatusMonitorResponseType = ServerStatusMonitorResponseType;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VydmVyU3RhdHVzTW9uaXRvclJlc3BvbnNlVHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TZXJ2ZXJTdGF0dXNNb25pdG9yL1NlcnZlclN0YXR1c01vbml0b3JSZXNwb25zZVR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQTtJQW9DRTs7O09BR0c7SUFDSCx5Q0FBWSxNQUFjO1FBQ3hCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO0lBQ3ZCLENBQUM7SUFsQ0Q7O09BRUc7SUFDSSxxQ0FBSyxHQUFaO1FBQ0UsT0FBTyxJQUFJLCtCQUErQixDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUN6RCxDQUFDO0lBRUQ7O09BRUc7SUFDSSx1Q0FBTyxHQUFkO1FBQ0UsT0FBTyxJQUFJLCtCQUErQixDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUMzRCxDQUFDO0lBRUQ7O09BRUc7SUFDSSxvQ0FBSSxHQUFYO1FBQ0UsT0FBTyxJQUFJLCtCQUErQixDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN4RCxDQUFDO0lBRUQ7O09BRUc7SUFDSSx1Q0FBTyxHQUFkO1FBQ0UsT0FBTyxJQUFJLCtCQUErQixDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUMzRCxDQUFDO0lBVUQ7O09BRUc7SUFDSSxtREFBUyxHQUFoQjtRQUNFLE9BQU8sSUFBSSxDQUFDLE1BQU0sQ0FBQztJQUNyQixDQUFDO0lBaERNLHFDQUFLLEdBQUcsT0FBTyxDQUFDO0lBaUR6QixzQ0FBQztDQUFBLEFBbERELElBa0RDO0FBbERZLDBFQUErQiJ9